import * as React from 'react';
import { useSelector } from 'react-redux';
import { Services } from './Services';
import {
  selectServiceIds,
  selectPublishTermsStatus,
  selectActiveServiceIndex,
} from '../../../../selectors/publishTerms';
import { EPublishTermsStatus } from '../../../../redux/reducers';
import { selectOfferId } from '../../../../selectors/offer';
import { trackScrollSlider, trackServicesVisible } from './Services.tracking';
import { ElementInViewport } from '../../../common/ElementInViewport';
import { useIsMobileDevice } from '../../../../hooks';

export const ServicesContainer: React.FC<{}> = () => {
  const serviceIds = useSelector(selectServiceIds);
  const status = useSelector(selectPublishTermsStatus);
  const activeServiceIndex = useSelector(selectActiveServiceIndex);
  const offerId = useSelector(selectOfferId);
  const isMobile = useIsMobileDevice();
  const isNewOffer = !offerId;

  const handleServicesVisible = React.useCallback(() => {
    trackServicesVisible(isNewOffer, serviceIds);
  }, [isNewOffer, serviceIds]);

  const handleScrollSliderRight = React.useCallback(() => {
    trackScrollSlider(isNewOffer, 'right');
  }, [isNewOffer]);

  const handleScrollSliderLeft = React.useCallback(() => {
    trackScrollSlider(isNewOffer, 'left');
  }, [isNewOffer]);

  if (status === EPublishTermsStatus.success) {
    return (
      <ElementInViewport threshold={0.25} onVisible={handleServicesVisible}>
        <Services
          serviceIds={serviceIds}
          isMobile={isMobile}
          activeServiceIndex={activeServiceIndex}
          onScrollSliderRight={handleScrollSliderRight}
          onScrollSliderLeft={handleScrollSliderLeft}
        />
      </ElementInViewport>
    );
  }

  return null;
};
